var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_6382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92603 1.43018H7.42603C7.69124 1.43018 7.9456 1.53553 8.13313 1.72307C8.32067 1.91061 8.42602 2.16496 8.42602 2.43018V5.93018C8.42602 6.19539 8.32067 6.44975 8.13313 6.63728C7.9456 6.82482 7.69124 6.93018 7.42603 6.93018H5.92603C5.39559 6.93018 4.88688 6.71946 4.51181 6.34439C4.13674 5.96932 3.92603 5.46061 3.92603 4.93018V3.43018C3.92603 2.89974 4.13674 2.39103 4.51181 2.01596C4.88688 1.64089 5.39559 1.43018 5.92603 1.43018V1.43018Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42603 2.93018H10.426",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42603 5.43018H10.426",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92578 4H1.92578C1.66056 4 1.40621 4.20018 1.21867 4.5565C1.03114 4.91282 0.925781 5.39609 0.925781 5.9V21.1C0.925781 21.6039 1.03114 22.0872 1.21867 22.4435C1.40621 22.7998 1.66056 23 1.92578 23H8.22874",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.926 6.93018H16.426C16.1608 6.93018 15.9065 6.82482 15.7189 6.63728C15.5314 6.44975 15.426 6.19539 15.426 5.93018V2.43018C15.426 2.16496 15.5314 1.91061 15.7189 1.72307C15.9065 1.53553 16.1608 1.43018 16.426 1.43018H17.926C18.4565 1.43018 18.9652 1.64089 19.3402 2.01596C19.7153 2.39103 19.926 2.89974 19.926 3.43018V4.93018C19.926 5.46061 19.7153 5.96932 19.3402 6.34439C18.9652 6.71946 18.4565 6.93018 17.926 6.93018V6.93018Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9257 4H21.9257C22.1909 4 22.4453 4.20018 22.6328 4.5565C22.8204 4.91282 22.9257 5.39609 22.9257 5.9V21.1C22.9257 21.6039 22.8204 22.0872 22.6328 22.4435C22.4453 22.7998 22.1909 23 21.9257 23H14.7708",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_6382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIcon);
export default __webpack_public_path__ + "static/media/connection_icon.7ed9516ead6e2ec8f651dab6760628f7.svg";
export { ForwardRef as ReactComponent };